
import { Component, Prop, Vue } from "vue-property-decorator";
import Typewriter from "./Typewriter.vue";
import TitleScene from "./TitleScene.vue";


@Component({
  components: { Typewriter, TitleScene },
})
export default class EndCredits extends Vue {
  audio = require("@/audio/Main_Theme.mp3")

  sound = localStorage.sound === 'true' ?? false;

  startCredits = false

  index = 0;

  finish() {
    this.next();
    setTimeout(()=>this.$router.push({name: 'Home'}), 4000)

  }

  mounted() {
    setTimeout(()=>this.startCredits = true, 0)
  }

  next() {
    setTimeout(()=>this.index++, 1000)

  }
}
